import { authRequest } from "./helper";

export const getAllProducts = () =>
  authRequest({
    method: "GET",
    url: "/items",
  })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => console.error("Error: ", error));

export const getPaginatedRecords = (payload: any) =>
  authRequest({
    method: "POST",
    url: "/allitems/",
    data: payload,
  })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => console.error("Error: ", error));

export const updateProducts = (payload: any) =>
  authRequest({
    method: "PUT",
    url: "/item",
    data: payload,
  })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => console.error("Error: ", error));

export const getAllFilters = (payload: any) =>
  authRequest({
    method: "POST",
    url: "/upcfilterslist",
    data: payload,
  })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => console.error("Error: ", error));

export const getMassApprovalStatus = (username: string) =>
  authRequest({
    method: "GET",
    url: `/massapproval/${username}`,
  })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => console.error("Error: ", error));

export const getProductsByUPC = (upc: string) =>
  authRequest({
    method: "GET",
    url: `/item/${upc}`,
  })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => console.error("Error: ", error));

export const getAuditLogs = (payload: any) =>
  authRequest({
    method: "POST",
    url: "/audit",
    data: payload,
  })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => console.error("Error: ", error));

export const getDownloadPresignedURL = () =>
  authRequest({
    method: "GET",
    url: "/downloadfile",
  })
    .then(({ data }) => data)
    .catch((error) => console.error("Error: ", error));
